import React, { useState } from "react";
import {
	MDBContainer,
	MDBRow,
	MDBFooter,
	MDBCol,
	MDBCard,
	MDBCardBody,
	MDBInput,
} from "mdbreact";

import logo from "../../images/logo.png";
import { Form, Input, Button, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import Firebase from "../Firebase/Firebase";
import { getAuth } from "firebase/auth";
import { getCallable } from "../Firebase/functionsClient";

const auth = getAuth(Firebase);

const sendPasswordResetLinkCallable = getCallable("sendPasswordResetLink");

const ForgotPassword = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);

	const onFinish = async (values) => {
		const email = values.email ? values.email.trim() : "";

		if (!email) {
			message.error("Please enter your email address!");
			return;
		}

		setLoading(true);
		try {
			const res = await sendPasswordResetLinkCallable({ email });
			message.success(
				"Password reset email sent. Please check your inbox (and spam folder)."
			);
			navigate("/login");
		} catch (error) {
			console.error("Forgot password error:", error);
			const errMsg =
				error?.message ||
				"Unable to send reset email. Please try again or contact support.";
			message.error(errMsg);
		} finally {
			setLoading(false);
		}
	};

	const handleBackToLogin = () => {
		navigate("/login");
	};

	return (
		<div className="bg-light vh-100 d-flex justify-content-center align-items-center">
			<MDBContainer>
				<MDBRow center={true}>
					<MDBCol md="4" lg="5" className="my-5">
						<MDBCardBody>
							<MDBRow className="mb-10">
								<MDBCol className="custom-table">
									<MDBCard className="bg-primary p-1 mb-3">
										<img
											src={logo}
											className="rounded mx-auto d-block"
											alt="logo"
										/>
									</MDBCard>
								</MDBCol>
							</MDBRow>

							<Typography.Title level={4} className="text-center mb-4">
								Reset your password
							</Typography.Title>

							<Form layout="vertical" onFinish={onFinish}>
								<Typography.Text className="text-primary">
									Email
								</Typography.Text>
								<Form.Item
									name="email"
									className="mb-0"
									rules={[
										{
											required: true,
											message: "Please enter your email address!",
										},
									]}
								>
									<MDBInput
										type="text"
										autoComplete="email"
										hint="Enter your email address"
									/>
								</Form.Item>
								<div className="text-center mt-4">
									<Button
										className="w-50"
										htmlType="submit"
										type="primary"
										size="large"
										loading={loading}
									>
										Send reset link
									</Button>
								</div>
							</Form>
						</MDBCardBody>

						<MDBFooter>
							<div className="text-center text-black-50 d-flex justify-content-center mt-2">
								<span className="text-[12px]">Remembered your password?</span>
								<a
									onClick={handleBackToLogin}
									href="#!"
									className=" text-primary text-[12px] ml-1"
								>
									Back to login
								</a>
							</div>
						</MDBFooter>
					</MDBCol>
				</MDBRow>
			</MDBContainer>
		</div>
	);
};

export default ForgotPassword;
